import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';
import { spacing16, spacing4 } from 'approot/shared/styles/spacing.style';
import { fontWeightBold } from 'approot/shared/styles/typography.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';

export const SubActivity = styled.div`
  ${baseFlexCss}
`;

export const SubActivityLabelWrapper = styled.div`
  display: flex;
  align-items: baseline;
  width: 100%;
`;

export const SubActivityLabel = styled.div`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}

  font-weight: ${fontWeightBold};
  display: inline;
  margin-bottom: ${rem(spacing16)};
  margin-right: ${rem(spacing4)};
`;

export const SubActivityInstruction = styled.div`
  margin-bottom: ${rem(6)};
  width: 100%;
`;
